// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForgotPassword_radioGroup__M-gVx {
  margin-bottom: 20px;
  display: flex;
  gap: 20px;
}

.ForgotPassword_radioLabel__KahmV {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
}

.ForgotPassword_radioLabel__KahmV input[type="radio"] {
  width: auto;
  margin: 0;
  cursor: pointer;
}

.ForgotPassword_radioLabel__KahmV span {
  cursor: pointer;
}

.ForgotPassword_forgotPasswordContainer__ICQQM {
    max-width: 400px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
    line-height: 1.6;
    text-align: center;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .ForgotPassword_title__7O7Qc {
    font-size: 1.8rem;
    margin-bottom: 10px;
    color: #333;
  }
  
  .ForgotPassword_subtitle__T0Pob {
    font-size: 1rem;
    color: #555;
    margin-bottom: 20px;
  }
  
  .ForgotPassword_form__BsOO7 {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  .ForgotPassword_inputGroup__RKBAN {
    text-align: left;
  }
  
  .ForgotPassword_label__Vpc9n {
    display: block;
    font-size: 0.9rem;
    margin-bottom: 5px;
    color: #444;
  }
  
  .ForgotPassword_input__qQ6R2 {
    width: 100%;
    padding: 8px 12px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }
  
  .ForgotPassword_input__qQ6R2:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 4px rgba(0, 123, 255, 0.25);
  }
  
  .ForgotPassword_submitButton__VnzdW {
    padding: 10px 15px;
    font-size: 1rem;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .ForgotPassword_submitButton__VnzdW:disabled {
    background-color: #b3d7ff;
    cursor: not-allowed;
  }
  
  .ForgotPassword_message__TRx2j {
    margin-top: 20px;
    font-size: 1rem;
    color: #28a745;
  }
  `, "",{"version":3,"sources":["webpack://./src/Component/ForgotPassword.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,2CAA2C;EAC7C;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB","sourcesContent":[".radioGroup {\n  margin-bottom: 20px;\n  display: flex;\n  gap: 20px;\n}\n\n.radioLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n}\n\n.radioLabel input[type=\"radio\"] {\n  width: auto;\n  margin: 0;\n  cursor: pointer;\n}\n\n.radioLabel span {\n  cursor: pointer;\n}\n\n.forgotPasswordContainer {\n    max-width: 400px;\n    margin: 0 auto;\n    padding: 20px;\n    font-family: Arial, sans-serif;\n    line-height: 1.6;\n    text-align: center;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .title {\n    font-size: 1.8rem;\n    margin-bottom: 10px;\n    color: #333;\n  }\n  \n  .subtitle {\n    font-size: 1rem;\n    color: #555;\n    margin-bottom: 20px;\n  }\n  \n  .form {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .inputGroup {\n    text-align: left;\n  }\n  \n  .label {\n    display: block;\n    font-size: 0.9rem;\n    margin-bottom: 5px;\n    color: #444;\n  }\n  \n  .input {\n    width: 100%;\n    padding: 8px 12px;\n    font-size: 1rem;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box;\n  }\n  \n  .input:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 4px rgba(0, 123, 255, 0.25);\n  }\n  \n  .submitButton {\n    padding: 10px 15px;\n    font-size: 1rem;\n    color: #fff;\n    background-color: #007bff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .submitButton:disabled {\n    background-color: #b3d7ff;\n    cursor: not-allowed;\n  }\n  \n  .message {\n    margin-top: 20px;\n    font-size: 1rem;\n    color: #28a745;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioGroup": `ForgotPassword_radioGroup__M-gVx`,
	"radioLabel": `ForgotPassword_radioLabel__KahmV`,
	"forgotPasswordContainer": `ForgotPassword_forgotPasswordContainer__ICQQM`,
	"title": `ForgotPassword_title__7O7Qc`,
	"subtitle": `ForgotPassword_subtitle__T0Pob`,
	"form": `ForgotPassword_form__BsOO7`,
	"inputGroup": `ForgotPassword_inputGroup__RKBAN`,
	"label": `ForgotPassword_label__Vpc9n`,
	"input": `ForgotPassword_input__qQ6R2`,
	"submitButton": `ForgotPassword_submitButton__VnzdW`,
	"message": `ForgotPassword_message__TRx2j`
};
export default ___CSS_LOADER_EXPORT___;
